"use client";

import useUserSession from "@/hooks/useSession";
import hotjar from "@hotjar/browser";
import { useEffect } from "react";
const siteId = process.env.NEXT_PUBLIC_HOTJAR_SITE_ID;
const hotjarVersion = 6;
export default function Hotjar() {
  const session = useUserSession();
  useEffect(() => {
    if (siteId) {
      hotjar.init(Number(siteId), hotjarVersion);
    }
  }, []);
  useEffect(() => {
    if (session?.accessToken) {
      hotjar.identify(session.email, {
        email: session.email
      });
    }
  }, [session?.accessToken, session?.email]);
  return null;
}